"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PIPELINE_OPS_UNLISTED_RUN_LIMIT = exports.PipelineOpsUnlistedReason = exports.AiAnalysisRecoveryBlockerKind = exports.AiAnalysisRecoveryMode = exports.PipelineOpsAction = exports.PipelineNetlistFailure = exports.PIPELINE_WORKFLOW_CLOSED_STATUSES = exports.PipelineWorkflowStatus = exports.PIPELINE_OPS_INTERNAL_BILLING_CLASS = exports.PIPELINE_OPS_EXCLUSIONS = exports.PipelineOpsExclusion = exports.PIPELINE_OPS_MAX_WINDOW_DAYS = exports.PIPELINE_OPS_DEFAULT_WINDOW_DAYS = exports.PIPELINE_AWAITING_STATE_BY_ATTRIBUTE = exports.PipelineAwaitingState = exports.NETLIST_WAIT_EXPIRED_WORKFLOW_STAGE = exports.PipelineStageState = exports.DeliveryHealthReason = exports.PIPELINE_STAGE_BY_BUILD_STATUS = exports.PIPELINE_STAGES = exports.PipelineStage = void 0;
exports.pipelineStageRank = pipelineStageRank;
exports.pipelineAwaitingStateFromAttribute = pipelineAwaitingStateFromAttribute;
exports.isPipelineOpsExclusion = isPipelineOpsExclusion;
exports.pipelineWorkflowStatusFromTemporal = pipelineWorkflowStatusFromTemporal;
const build_status_1 = require("./build-status");
var PipelineStage;
(function (PipelineStage) {
    PipelineStage["Upload"] = "upload";
    PipelineStage["Validate"] = "validate";
    PipelineStage["Resolve"] = "resolve";
    PipelineStage["BomReview"] = "bom_review";
    PipelineStage["Merge"] = "merge";
    PipelineStage["Netlist"] = "netlist";
    PipelineStage["AnalysisGate"] = "analysis_gate";
    PipelineStage["Analysis"] = "analysis";
    PipelineStage["Review"] = "review";
    PipelineStage["Deliver"] = "deliver";
})(PipelineStage || (exports.PipelineStage = PipelineStage = {}));
exports.PIPELINE_STAGES = [
    PipelineStage.Upload,
    PipelineStage.Validate,
    PipelineStage.Resolve,
    PipelineStage.BomReview,
    PipelineStage.Merge,
    PipelineStage.Netlist,
    PipelineStage.AnalysisGate,
    PipelineStage.Analysis,
    PipelineStage.Review,
    PipelineStage.Deliver,
];
exports.PIPELINE_STAGE_BY_BUILD_STATUS = {
    [build_status_1.BuildStatus.Pending]: PipelineStage.Upload,
    [build_status_1.BuildStatus.Validating]: PipelineStage.Validate,
    [build_status_1.BuildStatus.Processing]: PipelineStage.Resolve,
    [build_status_1.BuildStatus.BomAwaitingReview]: PipelineStage.BomReview,
    [build_status_1.BuildStatus.ProcessingBom]: PipelineStage.Merge,
    [build_status_1.BuildStatus.ReadyToAnalyze]: PipelineStage.AnalysisGate,
    [build_status_1.BuildStatus.ProcessingDesign]: PipelineStage.Analysis,
    [build_status_1.BuildStatus.AnalysisComplete]: PipelineStage.Review,
    [build_status_1.BuildStatus.Complete]: PipelineStage.Deliver,
};
var DeliveryHealthReason;
(function (DeliveryHealthReason) {
    DeliveryHealthReason["Breached"] = "breached";
    DeliveryHealthReason["AtRisk"] = "at_risk";
    DeliveryHealthReason["Stalled"] = "stalled";
    DeliveryHealthReason["Quiet"] = "quiet";
    DeliveryHealthReason["Good"] = "good";
    DeliveryHealthReason["StageOverdue"] = "stage_overdue";
    DeliveryHealthReason["Blocked"] = "blocked";
    DeliveryHealthReason["Abandoned"] = "abandoned";
    DeliveryHealthReason["TimedOut"] = "timed_out";
    DeliveryHealthReason["CreditRequired"] = "credit_required";
})(DeliveryHealthReason || (exports.DeliveryHealthReason = DeliveryHealthReason = {}));
var PipelineStageState;
(function (PipelineStageState) {
    PipelineStageState["Ahead"] = "ahead";
    PipelineStageState["Done"] = "done";
    PipelineStageState["Active"] = "active";
    PipelineStageState["Overdue"] = "overdue";
    PipelineStageState["Blocked"] = "blocked";
    PipelineStageState["Skipped"] = "skipped";
})(PipelineStageState || (exports.PipelineStageState = PipelineStageState = {}));
exports.NETLIST_WAIT_EXPIRED_WORKFLOW_STAGE = 'netlist-timed-out';
function pipelineStageRank(stage) {
    return exports.PIPELINE_STAGES.indexOf(stage);
}
var PipelineAwaitingState;
(function (PipelineAwaitingState) {
    PipelineAwaitingState["None"] = "none";
    PipelineAwaitingState["ParseErrorResolution"] = "parse_error_resolution";
    PipelineAwaitingState["NetlistUpload"] = "netlist_upload";
    PipelineAwaitingState["NetlistErrorReview"] = "netlist_error_review";
    PipelineAwaitingState["BomReview"] = "bom_review";
    PipelineAwaitingState["AnalysisStart"] = "analysis_start";
    PipelineAwaitingState["NetlistClearance"] = "netlist_clearance";
    PipelineAwaitingState["Delivery"] = "delivery";
    PipelineAwaitingState["Other"] = "other";
})(PipelineAwaitingState || (exports.PipelineAwaitingState = PipelineAwaitingState = {}));
exports.PIPELINE_AWAITING_STATE_BY_ATTRIBUTE = {
    parseErrorResolution: PipelineAwaitingState.ParseErrorResolution,
    netlistUpload: PipelineAwaitingState.NetlistUpload,
    netlistErrorReview: PipelineAwaitingState.NetlistErrorReview,
};
function pipelineAwaitingStateFromAttribute(attribute) {
    if (attribute === undefined || attribute === '') {
        return PipelineAwaitingState.None;
    }
    return exports.PIPELINE_AWAITING_STATE_BY_ATTRIBUTE[attribute] ?? PipelineAwaitingState.Other;
}
exports.PIPELINE_OPS_DEFAULT_WINDOW_DAYS = 7;
exports.PIPELINE_OPS_MAX_WINDOW_DAYS = 90;
var PipelineOpsExclusion;
(function (PipelineOpsExclusion) {
    PipelineOpsExclusion["ArchivedProject"] = "archived_project";
    PipelineOpsExclusion["DemoProject"] = "demo_project";
    PipelineOpsExclusion["InternalOrg"] = "internal_org";
    PipelineOpsExclusion["Superseded"] = "superseded";
    PipelineOpsExclusion["Dormant"] = "dormant";
    PipelineOpsExclusion["Delivered"] = "delivered";
})(PipelineOpsExclusion || (exports.PipelineOpsExclusion = PipelineOpsExclusion = {}));
exports.PIPELINE_OPS_EXCLUSIONS = [
    PipelineOpsExclusion.ArchivedProject,
    PipelineOpsExclusion.DemoProject,
    PipelineOpsExclusion.InternalOrg,
    PipelineOpsExclusion.Superseded,
    PipelineOpsExclusion.Dormant,
    PipelineOpsExclusion.Delivered,
];
function isPipelineOpsExclusion(value) {
    return Object.values(PipelineOpsExclusion).includes(value);
}
exports.PIPELINE_OPS_INTERNAL_BILLING_CLASS = 'internal';
var PipelineWorkflowStatus;
(function (PipelineWorkflowStatus) {
    PipelineWorkflowStatus["Running"] = "running";
    PipelineWorkflowStatus["Completed"] = "completed";
    PipelineWorkflowStatus["Failed"] = "failed";
    PipelineWorkflowStatus["Canceled"] = "canceled";
    PipelineWorkflowStatus["Terminated"] = "terminated";
    PipelineWorkflowStatus["TimedOut"] = "timed_out";
    PipelineWorkflowStatus["ContinuedAsNew"] = "continued_as_new";
})(PipelineWorkflowStatus || (exports.PipelineWorkflowStatus = PipelineWorkflowStatus = {}));
const PIPELINE_WORKFLOW_STATUS_BY_TEMPORAL_NAME = {
    RUNNING: PipelineWorkflowStatus.Running,
    COMPLETED: PipelineWorkflowStatus.Completed,
    FAILED: PipelineWorkflowStatus.Failed,
    CANCELED: PipelineWorkflowStatus.Canceled,
    CANCELLED: PipelineWorkflowStatus.Canceled,
    TERMINATED: PipelineWorkflowStatus.Terminated,
    TIMED_OUT: PipelineWorkflowStatus.TimedOut,
    CONTINUED_AS_NEW: PipelineWorkflowStatus.ContinuedAsNew,
};
function pipelineWorkflowStatusFromTemporal(name) {
    if (name === undefined) {
        return undefined;
    }
    return PIPELINE_WORKFLOW_STATUS_BY_TEMPORAL_NAME[name.toUpperCase()];
}
exports.PIPELINE_WORKFLOW_CLOSED_STATUSES = [
    PipelineWorkflowStatus.Completed,
    PipelineWorkflowStatus.Failed,
    PipelineWorkflowStatus.Canceled,
    PipelineWorkflowStatus.Terminated,
    PipelineWorkflowStatus.TimedOut,
    PipelineWorkflowStatus.ContinuedAsNew,
];
var PipelineNetlistFailure;
(function (PipelineNetlistFailure) {
    PipelineNetlistFailure["Generation"] = "generation";
    PipelineNetlistFailure["Validation"] = "validation";
})(PipelineNetlistFailure || (exports.PipelineNetlistFailure = PipelineNetlistFailure = {}));
var PipelineOpsAction;
(function (PipelineOpsAction) {
    PipelineOpsAction["NetlistUploaded"] = "netlist_uploaded";
    PipelineOpsAction["NetlistErrorsAccepted"] = "netlist_errors_accepted";
    PipelineOpsAction["AiAnalysisRecoveryStarted"] = "ai_analysis_recovery_started";
})(PipelineOpsAction || (exports.PipelineOpsAction = PipelineOpsAction = {}));
var AiAnalysisRecoveryMode;
(function (AiAnalysisRecoveryMode) {
    AiAnalysisRecoveryMode["FastMode"] = "fast_mode";
    AiAnalysisRecoveryMode["RetryOnly"] = "retry_only";
})(AiAnalysisRecoveryMode || (exports.AiAnalysisRecoveryMode = AiAnalysisRecoveryMode = {}));
var AiAnalysisRecoveryBlockerKind;
(function (AiAnalysisRecoveryBlockerKind) {
    AiAnalysisRecoveryBlockerKind["LiveLease"] = "live_lease";
    AiAnalysisRecoveryBlockerKind["AnalysisRunning"] = "analysis_running";
    AiAnalysisRecoveryBlockerKind["RunsUnknown"] = "runs_unknown";
    AiAnalysisRecoveryBlockerKind["OnDemandTrigger"] = "on_demand_trigger";
})(AiAnalysisRecoveryBlockerKind || (exports.AiAnalysisRecoveryBlockerKind = AiAnalysisRecoveryBlockerKind = {}));
var PipelineOpsUnlistedReason;
(function (PipelineOpsUnlistedReason) {
    PipelineOpsUnlistedReason["BuildNotShown"] = "build_not_shown";
    PipelineOpsUnlistedReason["BuildMissing"] = "build_missing";
})(PipelineOpsUnlistedReason || (exports.PipelineOpsUnlistedReason = PipelineOpsUnlistedReason = {}));
exports.PIPELINE_OPS_UNLISTED_RUN_LIMIT = 50;
//# sourceMappingURL=pipeline-ops.js.map